/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import React, { ReactNode, useState } from 'react';
import { VideoEncoding, VideoPreset } from 'livekit-client';
import { ScreenSharePresetsCalls, ScreenShareVideoEncodings, } from '@/context/call-context/screen-share-options.ts';
import { ScreenShareSettingsContext } from './screen-share-context';

/**
 * @param children
 * @constructor
 */
export const ScreenShareSettingsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [selectedSharePreset, setSelectedSharePreset] = useState<VideoPreset>(
    ScreenSharePresetsCalls.h720fps30
  );
  const [selectedEncoding, setSelectedEncoding] = useState<VideoEncoding>(
    ScreenShareVideoEncodings.h720p30
  );

  return (
    <ScreenShareSettingsContext.Provider
      value={{
        selectedSharePreset,
        setSelectedSharePreset,
        selectedEncoding,
        setSelectedEncoding,
      }}
    >
      {children}
    </ScreenShareSettingsContext.Provider>
  );
};
